import { render, staticRenderFns } from "./chapter_xu.vue?vue&type=template&id=6f1e7d72&"
import script from "./chapter_xu.vue?vue&type=script&lang=js&"
export * from "./chapter_xu.vue?vue&type=script&lang=js&"
import style0 from "./chapter_xu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports